import { createAsyncThunk } from '@reduxjs/toolkit';

import { getConnectionListService } from 'services/connection.service';

export const getConnectionList = createAsyncThunk(
  'connection/list',
  async (_, thunkApi) => {
    try {
      const response = await getConnectionListService();
      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);
